import request from "~/utils/http";

const productApi =
{
	get : async (id) =>
	{
		const url = `product/detail/${id}`;
		return await request.get(url);
	},
	gets : async (params) =>
	{
		const url = 'product';
		return await request.get(url, {params});
	},
	search : async (keyword) =>
	{
		const url = 'product/search';
		return await request.get(url, {params: {keyword}});
	},
	variations : async (id) =>
	{
		const url = `product/variations/${id}`;
		return await request.get(url);
	},
	options : async (params) =>
	{
		const url = 'product';
        const paramsWidthOption = {
            ...params,
            options: true,
        };
        return await request.get(url, {params: paramsWidthOption});
	},
	add : async (params) =>
	{
		const url = 'product';
		return await request.post(url, params);
	},
	update : async (params) =>
	{
		const url = `product/${params.id}`;
		return await request.post(url, params);
	},
	delete : async (id) =>
	{
		const url = `product/delete/${id}`;
		return await request.delete(url);
	},
	sync : async (params) =>
	{
		const url = 'product/sync';
		return await request.get(url, {params});
	},
};

export default productApi;
